import * as React from "react";

import { Viewport, ViewSmall, ViewMedium } from "bernie-view";

import { WizardTabbed } from "components/shared/StorefrontWizard/WizardTabbed/WizardTabbed";
import { WizardHero } from "components/shared/StorefrontWizard/WizardHero/WizardHero";
import { ExtendedFTNode } from "src/typings/flexFramework/FlexComponent";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";
import { UitkSpacingProps, UitkSpacing } from "uitk-react-spacing";

export const StorefrontWizardRegionBEXView = ({
  heroImageSrc,
  context,
  trackOnChangeTab,
  wizardFormChildren,
  wizardLOBs,
  wizardState,
  otherFormChildren,
  heading,
  subHeading,
  cdgTreatment,
}: {
  heroImageSrc: string;
  context: any;
  trackOnChangeTab: (tab: string) => void;
  wizardFormChildren: React.ReactElement[];
  wizardLOBs: ExtendedFTNode[];
  wizardState: ClientWizardStateStore;
  otherFormChildren: React.ReactElement[];
  cdgTreatment?: boolean;
  heading?: string;
  subHeading?: string;
}) => {
  const className = "StorefrontWizardRegionBEX";

  const regionSpacing: UitkSpacingProps = { padding: { blockend: "unset" }, margin: { blockend: "unset" } };

  const wizardHero = (
    <WizardHero
      heroImageSrc={heroImageSrc}
      heroImageFigureClassNames="bexHeroImageFigure"
      context={context}
      trackOnChangeTab={trackOnChangeTab}
      wizardFormChildren={wizardFormChildren}
      wizardLOBs={wizardLOBs}
      wizardState={wizardState}
      cdgTreatment={cdgTreatment}
      heading={heading}
      subHeading={subHeading}
    />
  );

  const wizardRender = cdgTreatment ? (
    wizardHero
  ) : (
    <Viewport>
      <ViewSmall>
        <WizardTabbed
          wizardLOBs={wizardLOBs}
          context={context}
          wizardFormChildren={wizardFormChildren}
          trackOnChangeTab={trackOnChangeTab}
        />
      </ViewSmall>
      <ViewMedium>{wizardHero}</ViewMedium>
    </Viewport>
  );

  return (
    <UitkSpacing {...regionSpacing}>
      <div className={`${className}`} data-testid="storefront-region">
        <div id="wizardMainRegion" data-testid="main-region">
          {wizardRender}
          {otherFormChildren}
        </div>
      </div>
    </UitkSpacing>
  );
};
